module.exports = __webpack_public_path__ + "fb2b3479194b0882abfd46d287f297ee.png";